import { Container, Grid } from "@mui/material";
import { LandingFactoid } from "../LandingFactoid/LandingFactoid";

export function ContentRendererFactoids(block: any) {
  const hasMany = block.items.length > 2;
  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      <Grid container spacing={2}>
        {block.items.map((factoid, index) => {
          return (
            <Grid item xs={12} sm={6} md={hasMany ? 4 : 6} key={index}>
              <LandingFactoid
                helpText={factoid.helpText}
                tooltipText={factoid.tooltipText}
                value={factoid.value}
                text={factoid.text}
              />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
}
